import React, { useCallback, useEffect, useRef, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { connect } from 'react-redux'
import {
  CustomCheckbox,
  CustomPanel,
  Loading,
  PageHeader,
  CustomDataTableHeader,
} from '../../../../components'
import Modal from './ModalTP'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as TpHttp from '../../../../services/api/https/settings/tp.http'
import * as OpCenterHttp from '../../../../services/api/https/settings/operation-center.http'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'

const INIT_DATA = {
  id: null,
  name: '',
  actived: false,
  show_vehicles_by: '',
  assoc_companies: [],
  assoc_emissores: [],
}

const ROWS_PADRAO = 10

const TP = ({ dispatch, history }) => {
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [loadingTable, setLoadingTable] = useState(false)
  const [tps, setTps] = useState([])
  const [totalRecords, setTotalRecords] = useState(0)
  const [first, setFirst] = useState(0)
  const [rows, setRows] = useState(ROWS_PADRAO)
  const [opCenters, setOpCenters] = useState([])
  const [showModal, setShowModal] = useState({ show: false, data: INIT_DATA })
  const [search, setSearch] = useState('')
  const searchTimer = useRef(null)

  const fetchPagina = useCallback(
    async ({ first, rows, searchTerm }) => {
      try {
        setLoadingTable(true)
        const retorno = await TpHttp.getTpsPaginados({
          page: Math.floor(first / rows),
          pageSize: rows,
          search: searchTerm,
        })
        setTps(retorno.rows)
        setTotalRecords(retorno.total)
        setFirst(first)
        setRows(rows)
      } catch (error) {
        dispatch(showMessageBox(null, error))
      } finally {
        setLoadingTable(false)
      }
    },
    [dispatch],
  )

  useEffect(() => {
    async function fetchInitialData() {
      try {
        const opsCentersResponse = await OpCenterHttp.getCentralOperacoes()
        setOpCenters(opsCentersResponse)
        await fetchPagina({ first: 0, rows: ROWS_PADRAO, searchTerm: '' })
      } catch (error) {
        dispatch(showMessageBox(null, error))
      } finally {
        setIsLoading(false)
      }
    }

    if (isLoading) {
      fetchInitialData()
    }
  }, [isLoading, dispatch, fetchPagina])

  // Events
  const onSearchChange = value => {
    setSearch(value)
    clearTimeout(searchTimer.current)
    searchTimer.current = setTimeout(() => {
      fetchPagina({ first: 0, rows, searchTerm: value })
    }, 600)
  }

  const onPage = e => {
    fetchPagina({ first: e.first, rows: e.rows, searchTerm: search })
  }

  const onSelectionChange = async tp => {
    if (!tp) return

    try {
      setLoadingTable(true)
      const data = await TpHttp.getTpById(tp.id)
      setShowModal({ show: true, data })
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setLoadingTable(false)
    }
  }

  const onModalSave = async tp => {
    setShowModal({ show: false, data: INIT_DATA })
    fetchPagina({ first, rows, searchTerm: search })
  }

  const onModalClose = () => {
    setShowModal({ show: false, data: INIT_DATA })
    fetchPagina({ first, rows, searchTerm: search })
  }

  return (
    <>
      <PageHeader>S.5 - Operadores Logísticos</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => setShowModal({ show: true, data: INIT_DATA })}
          onVoltar={history.goBack}
        >
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <DataTable
              value={tps}
              emptyMessage="Nenhuma informação foi encontrada"
              selectionMode="single"
              onSelectionChange={e => onSelectionChange(e.value)}
              lazy
              paginator
              rows={rows}
              first={first}
              totalRecords={totalRecords}
              loading={loadingTable}
              onPage={onPage}
              rowsPerPageOptions={[10, 20, 50]}
              header={<CustomDataTableHeader value={search} onChange={onSearchChange} />}
            >
              <Column field="id" header="Código" style={tableCellCentered(80)} />
              <Column field="name" header="Operador Logístico" />
              <Column
                field="actived"
                header="Ativo"
                style={{ textAlign: 'center', width: 100 }}
                body={tp => <CustomCheckbox disabled checked={tp.actived === 1} />}
              />
            </DataTable>
          )}
        </CustomPanel>
      </div>
      <Modal
        operationsCenters={opCenters}
        show={showModal.show}
        data={showModal.data}
        onModalClose={onModalClose}
        onModalSave={onModalSave}
      />
    </>
  )
}

export default connect()(withRouter(TP))
